/* unplugin-vue-components disabled */
import {Splitter, SplitterPanel} from 'primevue'
import SkillsList from './skills-list.vue'
import SkillEditor from './skill-editor.vue'
import {MAX_TEST_SKILLS} from './test-skills-defs'
import $settings from 'stores/settings'

const TEST_SKILLS_KEY = 'adm_test_skills'
const TEST_AGENTS_KEY = 'adm_test_agents'

export default {
  components: {SkillsList, SkillEditor, Splitter, SplitterPanel},
  data(){
    return {
      editing_idx: undefined,
      skills: undefined,
      agents: [],
      saving: false,
      saved_at: undefined
    }
  },
  computed: {
    limit_reached() {
      return this.skills.length >= MAX_TEST_SKILLS
    },
  },
  async mounted() {
    const [skills, agents] = await Promise.all([
      $settings.get(TEST_SKILLS_KEY, []),
      $settings.get(TEST_AGENTS_KEY, [])
    ])
    this.agents = agents
    this.skills = skills
    await this.$nextTick()
    if (this.skills.length > 0) this.$refs.editor.edit(this.skills[0], 0)
  },
  methods: {
    createSkill(draft) {
      if (this.limit_reached) return
      this.skills.push({...draft})
      this.save()
    },
    saveSkill(idx, draft) {
      const skill = this.skills[idx]
      if (skill) Object.assign(skill, draft)
      this.save()
    },
    deleteSkill(idx) {
      this.skills.splice(idx, 1)
      this.$refs.editor.onSkillDeleted(idx)
      this.save()
    },

    async save() {
      this.saving = true
      try {
        const skills = this.skills.map(skill => ({...skill}))
        await $settings.put(TEST_SKILLS_KEY, skills.length ? skills : null)
        this.saved_at = Date.now()
      }
      catch (err) {
        $utils.toasts.error(err)
      }
      this.saving = false
    }
  }
}
